import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AudiosComponent } from './audios.component';

const routes: Routes = [{ path: '', component: AudiosComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AudiosRoutingModule { }
